<template>
  <v-container>
    <v-overlay :value="loadingOverlay" opacity="0.7">
      <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div class="users">
      <v-dialog overlay-opacity="0.7" v-model="dialogTab" min-height="90vh" max-width="1150px" class="form-no-scroll"
        scrollable>
        <v-navigation-drawer width="300" v-model="dialogTab">
          <v-card color="primary" dark class="pl-0 rounded-0">
            <v-card color="primary">
              <v-card-text class="h-90">
                <v-list-item-subtitle class="f-16 mt-3 ml-3 mb-0 white--text">
                  <small>{{$t('component_details')}}</small>
                </v-list-item-subtitle>
                <v-list-item-title class="f-16 mt-0 ml-3 mb-3 white--text">{{selectedUserDetail.fullName}}
                </v-list-item-title>
                <v-tabs class="f-14" vertical v-model="tab" background-color="primary">
                  <v-tab ripple class="pl-0 f-13 text-left primary" router v-for="(item,i) in menuDialog"
                    :key="`sae-${i}`" :name="item.name">
                    <v-list-item>
                      <v-list-item-icon class="mr-2">
                        <img :src="item.icon ? item.icon : transparent" alt width="18" height="18" />
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.name" class="f-13 capitalize white--text"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-tab>
                </v-tabs>
              </v-card-text>
            </v-card>
          </v-card>
        </v-navigation-drawer>

        <div class="pa-0 form-scroll">
          <v-card class="pa-0 rounded-0">
            <v-card-text class="h-90">
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <salaries v-if="tab == 0" v-bind:userId="selectedUserId" />
                </v-tab-item>
                <v-tab-item>
                  <bpjs-personal v-if="tab == 1" v-bind:userId="selectedUserId" />
                </v-tab-item>
                <v-tab-item>
                  <tax-method v-if="tab == 2" v-bind:userId="selectedUserId" />
                </v-tab-item>
                <v-tab-item>
                  <tax-status v-if="tab == 3" v-bind:userId="selectedUserId" />
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>
        </div>
      </v-dialog>
      <v-dialog v-model="uploadDialog" max-width="680px">
        <v-form ref="form">
          <!-- Download Template -->
          <v-card class="pt-3">
            <v-card-title>
              <div class="row pb-0">
                <div class="col-10 pb-0">
                  <span class="headline ml-2">Upload {{ $t('sub_salary_component') }}</span>
                </div>
                <div class="col-2 text-right pb-0">
                  <v-btn icon right class="ml-auto" @click="uploadDialog = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
                <div class="col-12 pb-0">
                  <small class="ml-2 not-bold">Please do the step below :</small>
                </div>
                <div class="col-10 pb-0">
                  <span class="headline ml-2">1. Download Salary Form Template</span>
                </div>
              </div>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>

                  <v-col cols="12">
                    <v-select v-model="addItem.groupAccess" :items="groupNoALL" item-text="alias" item-value="id"
                      label="Select Group" :rules="rules3" multiple small-chips clearable required class="sae-required">
                      <template v-slot:prepend-item>
                        <v-list-item ripple @click="toggle">
                          <v-list-item-action>
                            <v-icon :color="
                              addItem.groupAccess.length > 0
                                ? 'indigo darken-4'
                                : ''
                            ">
                              {{ icon }}
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{$t('select_all')}}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-select v-model="addItem.payrollComponents" :items="payrollComponents" item-text="componentCode"
                      item-value="id" label="Select Salary Components" :rules="rules3" multiple small-chips clearable required class="sae-required">
                      <template v-slot:prepend-item>
                        <v-list-item ripple @click="toggle2">
                          <v-list-item-action>
                            <v-icon :color="
                              addItem.payrollComponents.length > 0
                                ? 'indigo darken-4'
                                : ''
                            ">
                              {{ icon2 }}
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{$t('select_all')}}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                      <!-- <template v-slot:item="{ item }">
                        <div class="d-flex">
                          <div>
                            <v-checkbox
                              v-model="item"
                            ></v-checkbox>
                          </div>

                          <div>
                            {{ item.componentCode }}
                            <p style="color: #3277D5; font-size: 12px;">
                              {{ item.type }} - {{ item.name }}
                            </p>
                          </div>
                        </div>
                      </template> -->
                    </v-select>
                  </v-col>
                  <v-row justify="end">
                    <v-col cols="4" class="mr-4">
                      <v-btn block color="primary" :disabled="checkValidDownloadForm" class="mt-3" @click="downloadTemplate()">Download Template</v-btn>
                    </v-col>
                  </v-row>

                </v-row>
              </v-container>
            </v-card-text>

            <!-- Upload Template -->
            <v-card-title>
              <div class="row pb-0">
                <div class="col-12 pb-0">
                  <span class="headline ml-2">2. Upload Filled Salary Form</span>
                </div>
                <div class="col-12 pb-0">
                  <p class="mx-4 not-bold" style="color: #1976D2; font-size: 16px; word-break: break-word;">Please
                    upload
                    file according to the template (make sure the selected group is the same as downloaded one)</p>
                </div>
              </div>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-file-input v-model="uploadData.upload.file"
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      :label="$t('template_file')"></v-file-input>
                  </v-col>
                  <!-- <v-row justify="end">
                    <v-col cols="6" v-if="uploadData.upload.loading">
                      <i style="color:#E64A4D !important;">Please do not close when uploading or you will start all over
                        again!</i>
                    </v-col>
                  </v-row> -->
                </v-row>
                <div class="d-flex justify-end align-center" style="gap: 8px;">
                  <i v-if="uploadData.upload.loading" style="color:#E64A4D !important;">Please do not close when uploading or you will start all over
                    again!</i>
                  <v-btn :loading="uploadData.upload.loading" color="primary"
                    @click="uploadComponentTemplate">Upload {{ $t('sub_salary_component') }}</v-btn>
                </div>
              </v-container>
            </v-card-text>
          </v-card>
        </v-form>
      </v-dialog>
      <v-card class="mb-3 px-6">
        <v-row style="align-items: center;">
          <v-col style="position: relative;" class="search_employee mb-n5">
            <v-text-field label="Search here" :rules="[validator.alfaNumberNotRequired]"
              prepend-inner-icon="mdi-magnify" single-line v-model="search.keyword" @keyup.enter="fetchUsers()">
            </v-text-field>
          </v-col>
          <!-- <v-col>
            <v-select :items="[{id: false, name: $t('active')},{id: true, name: $t('all')}]" :label="$t('status')"
              item-text="name" item-value="id" @change="showActiveUsers($event)"></v-select>
          </v-col> -->

          <!-- <v-col>
            <v-select
              :items="roles"
             :placeholder="$t('access_type')"
              v-model="search.role"
              item-text="name"
              item-value="id"
              @change="fetchUsers()"
            ></v-select>
          </v-col> -->
          <v-col style="position: relative;" class="search_group mb-n5">
            <v-select :items="groupList" item-text="alias" item-value="id" placeholder="Set group here"
              v-model="search.groups" @change="fetchUsers()"></v-select>
          </v-col>
          <v-col style="position: relative;" class="search_type mb-n5">
            <v-select :items="[
              { name: $t('all'), id: null },
              { name: $t('shifting'), id: true },
              { name: $t('regular'), id: false },
            ]" placeholder="Set type here" item-text="name" item-value="id" @change="showShiftingUsers($event)">
            </v-select>
          </v-col>
          <!-- <v-col>
            <v-select
              v-model="showUsersResignOnly"
              :items="[{id: 1, name: $t('resigned')},{id: 0, name: $t('still_working')}]"
             :label="$t('employee_status')"
              item-text="name"
              item-value="id"
              @change="showResignUsers($event)"
            ></v-select>
          </v-col> -->
          <v-col md="4" sm="12">
            <v-btn color="primary" style="height: 36px;" block @click="showUploadDialog">
              <img src="/img/upload.svg" class="mr-4">Upload {{ $t('sub_salary_component') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-data-table :loading="loading" :headers="headers" :items="users" class="elevation-1"
            :server-items-length="totalData" :items-per-page="itemPerPage"
            :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }"
            :page="page" disable-sort @update:page="fetchUsers($event, itemPerPage)"
            @update:items-per-page="fetchUsers(page, $event)" @current-items="filteredUser"
            :no-data-text="$t('no_data')" height="550px">
            <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}}
              {{ items.itemsLength }} </template>
              <template
        v-slot:item.no="{ item }"
      >{{users.map(function(x) {return x.id; }).indexOf(item.id) + 1}}</template>
            <template v-slot:item.action="{ item }">
              <v-row align="center">
                <v-btn color="primary accent-3" @click="selectedUserChange(item)" icon small>
                  <v-icon>mdi-card-account-details-outline</v-icon>
                </v-btn>
              </v-row>
            </template>
            <template v-slot:item.register_user="{ item }">
              <div v-if="item.id.length == 28">
                <v-icon small class="ml-3" color="success">mdi-check-circle-outline</v-icon>
              </div>
              <div v-else>
                <v-icon small class="ml-3" color="error">mdi-close-circle-outline</v-icon>
              </div>
            </template>
            <template v-slot:item.status="{ item }">
              <div v-if="item.status == 1">
                <v-tooltip top color="success">
                  <template v-slot:activator="{ on, attrs }">
                    <b v-bind="attrs" v-on="on" class="cursor text-primary">
                      <v-icon small class="ml-3" color="success">mdi-check-circle-outline</v-icon>
                    </b>
                  </template>
                  <span>Active</span>
                </v-tooltip>
              </div>
              <div v-else>
                <v-tooltip top color="error">
                  <template v-slot:activator="{ on, attrs }">
                    <b v-bind="attrs" v-on="on" class="cursor text-primary">
                      <v-icon small class="ml-3" color="error">mdi-close-circle-outline</v-icon>
                    </b>
                  </template>
                  <span>{{$t('active')}}</span>
                </v-tooltip>
                <v-switch inset color="error" disabled></v-switch>
              </div>
            </template>
            <template v-slot:item.employeeBaseSalary="{ item }">
              <div v-if="item.employeeBaseSalary">Rp {{toNumeral(item.employeeBaseSalary)}}</div>
              <div v-else>-</div>
            </template>
            <template v-slot:item.role="{ item }">
              <div v-if="item.role == 0">Admin HRD</div>
              <div v-else-if="item.role == 1">Staff</div>
              <div v-else-if="item.role == 2">Admin Appsensi</div>
              <div v-else-if="item.role == 3">Supervisor</div>
              <div v-else-if="item.role == 4">Executive</div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<script>
  import axios from 'axios';
  import moment from "moment";
  import numeral from 'numeral'
  import Salaries from './Salaries.vue';
  import TaxMethod from './TaxMethod.vue'
  import TaxStatus from './TaxStatus.vue'
  import bpjsPersonal from './BPJSPersonal.vue';

  export default {
    name: "users",
    components: {
      Salaries,
      TaxMethod,
      TaxStatus,
      bpjsPersonal,
    },
    data() {

      return {
        payrollComponents: [],
        uploadDialog: false,
        addItem: {
          categoryCode: "",
          categoryName: "",
          groupAccess: [],
          payrollComponents: [],
        },
        uploadData: {
          upload: {
            groupId: null,
            file: null,
            loading: false,
          },
          download: {
            groupId: null,
            month: null,
            year: null,
            loading: false,
          }
        },
        transparent: 'img/menu_icon/transparent.png',
        menuDialog: [{
            id: 1,
            name: this.$i18n.t('component_items'),
            icon: 'img/menu_dialog/component_item.png'
          },
          {
            id: 4,
            name: 'BPJS',
            icon: 'img/menu_dialog/bpjs.png'
          },
          {
            id: 2,
            name: this.$i18n.t('tax_method'),
            icon: 'img/menu_dialog/tax_method.png'
          },
          {
            id: 3,
            name: this.$i18n.t('tax_status'),
            icon: 'img/menu_dialog/tax_status.png'
          },
        ],
        loadingOverlay: false,
        selectedUserId: null,
        selectedUserDetail: {},
        tab: null,
        dialogTab: false,
        loadingDownload: false,
        saveLoading: false,
        loadingSearch: false,
        dataSearch: [],
        check_role: this.$store.state.role,
        title: `Data Employee - ${this.$store.state.companyName
        } - ${moment().format("DD-MM-YYYY HHmm")}`,
        search: {
          keyword: "",
          role: ""
        },
        searchForm: '',
        validator: this.$store.state.validator,
        baseUrl: this.$store.state.baseUrl,
        dialogSchedule: false,
        user_full_detail: {
          group: {
            alias: ""
          }
        },
        disableSort: true,
        page: 1,
        itemPerPage: 10,
        totalData: 0,
        userAbility: "",
        nUserStatus: {
          active: "",
          message: "",
        },
        users: [{
          id: "",
          email: "",
          fullName: "",
        }, ],
        loading: true,
        headers: [
          { text: "No", value: "no" },
          {
            text: this.$i18n.t('employee_name'),
            value: "fullName"
          },
          {
            text: this.$i18n.t('group/departement'),
            value: "groupName"
          },
          {
            text: this.$i18n.t('email'),
            value: "email"
          },
          {
            text: this.$i18n.t('base_salary'),
            value: "employeeBaseSalary"
          },
          {
            text: this.$i18n.t('status'),
            value: "status"
          },
          {
            text: this.$i18n.t('action'),
            value: "action"
          },
        ],
        radios: "",
        tempUsers: [],
        users_report: [],
        usersReportFiltered: [],
        usersLength: 0,
        showUsersActiveOnly: false,
        showUsersResignOnly: 0,
        showUsersShiftingOnly: null,
        groupList: [],
        groupNoALL: [],
        groupListSelection: [],
        editedIndex: -1,
        dialog: false,
        scheduleHeaders: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        loadingDetails: false,
        detailsDialog: false,
        detailsItem: {},
        detailSchedule: {},
        detailZone: [],
        user_detail: [],
        addDialog: false,
        company_id: this.$store.state.company,
        deleteDialog: false,
        role: [{
            name: "Admin HRD",
            id: 0,
          },
          {
            name: "Staff",
            id: 1,
          },
          // { name: "Admin Appsensi", id: 2 },
          {
            name: "Supervisor",
            id: 3,
          },
          {
            name: "Executive",
            id: 4,
          },
        ],
        roles: [{
          name: this.$i18n.t('all'),
          id: "-"
        }],
        rules: [(value) => (value === 0 ? true : !!value || this.$i18n.t('required'))],
        rules2: [(value) => (value == 0 ? true : value ? value > 0 : !!value || this.$i18n.t('required'))],
        rules3: [(v) => v.length > 0 || this.$i18n.t('required')],
        validAdd: true,
        validEdit: true,
        emailRules: [
          (v) => !!v || this.$i18n.t('required'),
          (v) => /.+@.+\..+/.test(v) || this.$i18n.t('email_required'),
        ],
        nameRules: [
          (v) => !!v || this.$i18n.t('required'),
          (v) => (v && v.length <= 50) || "Name must be less than 50 characters",
        ],
        checkbox: true,
        disableInput: true,
      };
    },
    computed: {
      checkValidDownloadForm() {
        if (this.addItem.groupAccess.length > 0 && this.addItem.payrollComponents.length > 0) {
          return false
        }
        return true
      },
      addAllGroup() {
        return this.addItem.groupAccess.length === this.groupNoALL.length;
      },
      addAll() {
        return this.addItem.groupAccess.length > 0 && !this.addAllGroup;
      },
      addAllGroup2() {
        return this.addItem.payrollComponents.length === this.payrollComponents.length;
      },
      addAll2() {
        return this.addItem.payrollComponents.length > 0 && !this.payrollComponents;
      },
      icon() {
        if (this.addAllGroup) return "mdi-close-box";
        if (this.addAll) return "mdi-minus-box";
        return "mdi-checkbox-blank-outline";
      },
      icon2() {
        if (this.addAllGroup2) return "mdi-close-box";
        if (this.addAll2) return "mdi-minus-box";
        return "mdi-checkbox-blank-outline";
      },
      formTitle() {
        return this.editedIndex === -1 ? "New Item" : "Edit User";
      },
    },
    methods: {
      uploadFile(foo){
        // eslint-disable-next-line no-console
        console.log(foo)
      },
      async downloadTemplate() {
        let groupAccess = []
        let componentsPayroll = []

        if (this.icon == "mdi-close-box") {
          this.addItem.groupAccess.map((e) => {
            groupAccess.push(e.id);
          });
        } else {
          groupAccess = this.addItem.groupAccess;
        }

        if (this.icon2 == "mdi-close-box") {
          this.addItem.payrollComponents.map((e) => {
            componentsPayroll.push(e.id);
          });
        } else {
          componentsPayroll = this.addItem.payrollComponents;
        }

        const blob = {
          responseType: 'blob'
        }
        const headers = {
          headers: {
            userId: this.$store.state.user.id
          }
        }
        const body = {
          components: componentsPayroll,
          groups: groupAccess
        }
        const url = `${this.baseUrl}/v3/payroll/downloadComponentTemplate?companyId=${this.company_id}`
        const result = await axios.post(url, body, blob, headers).catch(() => {
          return null
        })
        if (result) {
          if (result.data) {
            const url = window.URL.createObjectURL(new Blob([result.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'file.xls');
            link.click();
          }
        }
      },
      async getPayrollComponent(status = 1) {
        return await this.$store.dispatch('getPayrollComponent', {
          status
        })
      },
      toggle() {
        this.$nextTick(() => {
          if (this.addAllGroup) {
            this.addItem.groupAccess = [];
          } else {
            this.addItem.groupAccess = this.groupNoALL.slice();
          }
        });
      },
      toggle2() {
        this.$nextTick(() => {
          if (this.addAllGroup2) {
            this.addItem.payrollComponents = [];
          } else {
            this.addItem.payrollComponents = this.payrollComponents.slice();
          }
        });
      },
      showUploadDialog() {
        this.uploadDialog = true
        if (this.role == 3) {
          const groupId = this.$store.state.user.detail.groupId
          this.uploadData.upload.groupId = groupId
          this.uploadData.download.groupId = groupId
        }
      },
      toNumeral(number) {
        return numeral(number).format("0,0");
      },
      addMargin(name = '') {
        return name.length <= 34 ? 'mt-4' : 'mt-2'
      },
      changeTab(tab) {
        this.tab = tab
      },
      async selectedUserChange(item, reload = false) {
        if (item != null) {
          this.selectedUserId = item.id
          this.selectedUserDetail = item
          this.loadingOverlay = true
          if (!reload) {
            this.tab = 0
          } else {
            this.fetchUsers()
          }
          this.loadingOverlay = false
          this.dialogTab = true
        }
      },
      changeRules(data) {
        if (data == true) {
          this.disableInput = true;
        } else {
          this.disableInput = false;
        }
      },
      getRole(role) {
        switch (role) {
          case 0:
            return "Admin HRD";
          case 1:
            return "Staff";
          case 3:
            return "Supervisor";
          case 4:
            return "Executive";
        }
      },
      changeNUserStatus(status) {
        if (status) {
          this.nUserStatus.active = "Active User";
          this.nUserStatus.message = "Means this user can access a certain page";
        } else {
          this.nUserStatus.active = "Inactive User";
          this.nUserStatus.message = "This user has no more access";
        }
      },
      changeUserRole(role) {
        switch (role) {
          case 0:
            this.userAbility =
              "Access all menus in the web application dashboard and view the reports of all employees.";
            break;
          case 1:
            this.userAbility =
              "Can only access the mobile application (Can’t access web dashboard).";
            break;
          case 3:
            this.userAbility =
              "Can only access the report and view the data reports belonging to each group’s corresponding hierarchy.";
            break;
          case 4:
            this.userAbility =
              "Can only access the report and view the data of all employees.";
            break;
        }
      },
      showResignUsers(data) {
        this.showUsersResignOnly = data;
        this.fetchUsers(this.page, this.itemPerPage);
      },
      showActiveUsers(data) {
        this.showUsersActiveOnly = !data;
        this.fetchUsers(this.page, this.itemPerPage, !data);
      },
      showShiftingUsers(data) {
        this.showUsersShiftingOnly = data;
        this.fetchUsers(this.page, this.itemPerPage, data);
      },
      filteredUser(data) {
        if (this.usersLength != data.length) {
          this.usersLength = data.length;
          this.usersReportFiltered = [];
          data.map((row) => {
            const user = {
              EmployeeCode: row.employee_code,
              Name: row.fullName,
              Email: row.email,
              Position: row.job_position,
              Level: row.level,
              Register: this.statusRegister(row.is_registered),
            };
            this.usersReportFiltered.push(user);
          });
        }
      },
      shortenTime(time) {
        return moment(time, "HH:mm:ss").format("HH:mm");
      },
      formatTime(date) {
        return moment(date).format("Do MMMM YYYY, HH:mm");
      },
      statusRegister(registered = null) {
        if (registered == true) {
          return "Registered";
        } else {
          return "Unregistered";
        }
      },
      statusRegisterAlternative(userId = '') {
        if (userId.length == 28) {
          return "Registered";
        } else {
          return "Unregistered";
        }
      },
      close() {
        this.dialog = false;
        this.addDialog = false;
      },
      showMessage(type, msg) {
        this.$store.dispatch('nShowMessage', {
          type,
          msg
        })
      },
      async uploadComponentTemplate() {
        if (this.uploadData.upload.file == null) return null
        this.uploadData.upload.loading = true

        const formData = new FormData();
        formData.append('payrollData', this.uploadData.upload.file);
        formData.append('companyId', this.company_id);

        const result = await this.$store.dispatch('uploadComponentTemplate',  formData)
        this.uploadData.upload.loading = false
        if (result) {
          this.uploadData.upload.loading = false
          this.showMessage('success', 'Berhasil Di upload')
          this.refreshData()
          this.uploadDialog = false
        }
      },
      async fetchUsers(page = 1, itemPerPage = 10, status = true) {
        this.page = page;
        this.itemPerPage = itemPerPage;
        const totalPageSend = itemPerPage < 1 ? this.totalData : itemPerPage;
        const start = this.page;
        let params = {
          companyId: this.company_id,
          page: start,
          pageSize: totalPageSend
        }
        if (this.search.keyword.length > 0) params.keyword = this.search.keyword
        if (this.search.role.toString() != "" && this.search.role.toString() != "-") params.role = this.search.role
        if (status != false) {
          params.status = 1
        }
        if (this.search.groups) params.groupId = this.search.groups
        if (this.showUsersShiftingOnly != null) params.isShifted = this.showUsersShiftingOnly
        if (this.showUsersResignOnly) params.isResign = this.showUsersResignOnly

        this.loading = true;
        const result = await this.$store.dispatch('getEmployeeSalariesUser', params)
        this.totalData = result.count
        this.users = result.rows
        this.loading = false;
      },
      async fetchGroupDetails() {
        const result = await this.$store.dispatch('getGroupByCompany', {
          companyId: this.company_id
        })
        this.groupList = result;
        this.groupListSelection = [].concat(result);
        this.groupList.unshift({
          alias: this.$i18n.t('all'),
          id: null
        });
      },
      async fetchGroupNoALL() {
        const result = await this.$store.dispatch('getGroupByCompany', {
          companyId: this.company_id
        })
        this.groupNoALL = result;
      },
      refreshData() {
        this.addDialog = false
        this.fetchUsers();
        this.fetchGroupDetails();
        this.fetchGroupNoALL();
      },
    },
    async beforeMount() {
      this.fetchUsers();
      this.payrollComponents = await this.getPayrollComponent()
      // eslint-disable-next-line no-console
      // console.log(this.payrollComponents)
      this.fetchGroupDetails();
      this.fetchGroupNoALL();
      this.role.map((item) => {
        this.roles.push(item);
      });
    },
    watch: {
      uploadDialog() {
        if (!this.uploadDialog) {
          this.addItem.groupAccess = []
          this.addItem.payrollComponents = []
          this.uploadData.upload.file = null
        }
      }
    },
  };
</script>
<style>
  .search_employee::before {
    content: 'Search Employee';
    position: absolute;
    bottom: 75px;
    font-size: 12px;
    color: #686868;
    left: 10px;
    height: 10px;
  }

  .search_group::before {
    content: 'Find Group';
    position: absolute;
    bottom: 75px;
    font-size: 12px;
    color: #686868;
    left: 10px;
    height: 10px;
  }

  .search_type::before {
    content: 'Schedule Type';
    position: absolute;
    bottom: 75px;
    font-size: 12px;
    color: #686868;
    left: 10px;
    height: 10px;
  }
</style>
<style scoped>
  .break-word {
    word-break: break-all;
    white-space: normal;
  }

  .line-height {
    height: 40px;
    overflow: hidden;
  }

  .mw-250 {
    max-width: 250px;
    min-width: 10px;
  }

  .middle {
    vertical-align: middle;
  }

  .justify {
    text-align: justify;
  }

  .h-90 {
    min-height: 90vh;
  }

  .h-80 {
    min-height: 80vh;
  }

  /* .v-list-item__title {
    color: #fff;
  } */

  :not(.v-list-group__header).v-list-item--active .v-list-item__title {
    color: #033a6d !important;
    caret-color: #033a6d !important;
    font-weight: 700;
  }

  .v-list-item--link:before {
    background-color: #a9cefc !important;
  }

  .f-16 {
    font-size: 16px !important;
    /* font-weight: 700 !important; */
    letter-spacing: 1.5px !important;
  }

  .f-13 {
    font-size: 13px !important;
  }

  .cursor {
    cursor: pointer;
  }

  .text-primary {
    color: #033a6d !important;
  }

  .v-list-item__mask {
    background: #b3d4fc !important;
  }
</style>